import { HttpClient } from '@angular/common/http';
import { Injectable, Input } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ReconsService } from '../api/services';

@Injectable({
  providedIn: 'root'
})
export class GridDataService {

  public data$: BehaviorSubject<any> = new BehaviorSubject(null);

  @Input() parameters!: any;

  
  constructor(private _http: HttpClient, private reconService: ReconsService) {

  }

  fetchData(): Observable<any> {
    console.log("params", this.parameters);
    return this.reconService.reconsgetReconAllDataApiReconsGetReconAllDataPost({body: this.parameters});
  }
  
}
